import { createTriplet } from '../test-procedure/createTriplet';
export var createTestStep = function () { return ({
    challenge: createTriplet(),
    snr: undefined,
    passed: false,
}); };
export var createDinTestSteps = function (numberOfSteps) {
    if (numberOfSteps === void 0) { numberOfSteps = 23; }
    var steps = new Set();
    while (steps.size < numberOfSteps) {
        steps.add(createTestStep());
    }
    return Array.from(steps);
};
export var calculateNextSnr = function (previousSnr, didPassPrevious, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.stepSize, stepSize = _c === void 0 ? 4 : _c, _d = _b.maxSnr, maxSnr = _d === void 0 ? 8 : _d, _e = _b.minSnr, minSnr = _e === void 0 ? -22 : _e;
    var result = previousSnr;
    if (didPassPrevious)
        result -= stepSize;
    else
        result += stepSize;
    if (result > maxSnr)
        result = maxSnr;
    if (result < minSnr)
        result = minSnr;
    return result;
};
export var compareTriplets = function (challenge, response) {
    return challenge.every(function (challengeDigit, index) { return challengeDigit === response[index]; });
};
export var toTriplet = function (array) {
    return array.map(function (digit) { return parseInt(digit); });
};
export var average = function (arr) {
    return arr.reduce(function (a, b) { return a + b; }, 0) / arr.length;
};
export var defaultCutOffs = [
    { snr: -15.7, category: 'normal' },
    { snr: -13.7, category: 'mild' },
    { snr: 100, category: 'moderate' },
    { snr: Infinity, category: 'severe' },
];
export var getCategory = function (snr, cutoffs) {
    var _a;
    if (cutoffs === void 0) { cutoffs = defaultCutOffs; }
    return ((_a = cutoffs.find(function (cutoff) { return snr < cutoff.snr; })) === null || _a === void 0 ? void 0 : _a.category) || '';
};
export function getNormalizedScoreDichotic(resultSNR) {
    if (resultSNR <= -19) {
        return resultSNR * (-1 / 0.3) + 26 + 2 / 3;
    }
    if (resultSNR <= -17.2) {
        return resultSNR * (-1 / 0.2) - 5;
    }
    if (resultSNR <= -12) {
        return resultSNR * (-1 / 0.1) - 90;
    }
    if (resultSNR <= 0) {
        return resultSNR * (-1 / 0.4);
    }
    return 0;
}
export var scale = function (value, inMin, inMax, outMin, outMax) {
    var result = ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    if (result < outMin)
        return outMin;
    if (result > outMax)
        return outMax;
    return result;
};
var roundToNearestDecimal = function (value, decimal) {
    var factor = Math.pow(10, decimal);
    return Math.round(value * factor) / factor;
};
var getSnrIndex = function (snr, cutoffs) {
    return cutoffs.indexOf(cutoffs.find(function (cutoff) { return snr <= cutoff.snr; }));
};
export var getScoreGraphValue = function (snr, cutoffs, markers) {
    if (cutoffs === void 0) { cutoffs = [
        {
            snr: -22,
            category: 'min',
        },
        {
            snr: -15.7,
            category: 'normal',
        },
        {
            snr: -13.7,
            category: 'mild',
        },
        {
            snr: 8,
            category: 'max',
        },
    ]; }
    if (markers === void 0) { markers = [100, 72.5, 27.5, 0]; }
    if (cutoffs.length !== markers.length)
        throw new Error('Invalid markers for given cutoffs, cutoffs.length !== markers.length');
    if (snr <= cutoffs[0].snr)
        return markers[0];
    if (snr > cutoffs[cutoffs.length - 1].snr)
        return markers[markers.length - 1];
    var snrIndex = getSnrIndex(snr, cutoffs);
    return roundToNearestDecimal(scale(snr, cutoffs[snrIndex].snr, cutoffs[snrIndex - 1].snr, markers[snrIndex], markers[snrIndex - 1]), 1);
};
